import {PaymentMethodController} from "./PaymentMethodController.js";
import {SubscriptionFlowPlanState} from "./SubscriptionFlowPlanState.js";
import {AddressController} from "./AddressController.js";


// These are instantiated in the flow state classes and throughout the inline user dashboard
export const Controller = {
    paymentMethod: new PaymentMethodController(),
    subscriptionPlan: new SubscriptionFlowPlanState(),
    address: new AddressController(),
}
